import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";

import { apiRequest } from "@mhj/shared/api";
import { Card, Field, buttonClass, inputClass } from "../lib/ui";

/**
 * For applicants a field officer registered. They hold a code sent by SMS and
 * have never had a password.
 */
export default function ClaimAccount() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ phone: "", code: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      await apiRequest("/auth/claim-account", {
        method: "POST",
        data: { phone: form.phone.trim(), code: form.code.trim(), password: form.password },
      });
      toast.success("Your account is ready. Sign in with your new password.");
      navigate("/login");
    } catch (error) {
      toast.error((error as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card
      title="Set up your account"
      description="If an officer registered you, use the code from your text message to choose a password."
    >
      <form className="space-y-4" onSubmit={submit}>
        <Field label="Phone number" required>
          <input
            className={inputClass}
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
            type="tel"
            inputMode="tel"
            placeholder="08031234567"
          />
        </Field>
        <Field label="Code from your text message" required>
          <input
            className={inputClass}
            value={form.code}
            onChange={(e) => setForm({ ...form, code: e.target.value })}
            inputMode="numeric"
            placeholder="483012"
          />
        </Field>
        <Field label="Choose a password" required hint="At least 8 characters.">
          <input
            className={inputClass}
            type="password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            autoComplete="new-password"
          />
        </Field>
        <button type="submit" className={buttonClass} disabled={busy}>
          {busy ? "Setting up…" : "Set up my account"}
        </button>
      </form>
    </Card>
  );
}
